import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import Products from "./components/Products";
import About from "./components/About";
import Contact from "./components/Contact";
import ReturnRefundPolicy from "./components/terms/ReturnRefundPolicy";
import PrivacyPolicy from "./components/terms/PrivacyPolicy";
import Responsibility from "./components/terms/Responsibility";
import LegalDisclaimer from "./components/terms/LegalDisclaimer";
import MessagingPolicy from "./components/terms/messaging-policy";

import "./App.css";

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />

        <main className="content">
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Home />
                  <Products />
                  <About />
                  <Contact />
                </>
              }
            />
            <Route path="/terms-conditions" element={<Responsibility />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/return-refund-policy" element={<ReturnRefundPolicy />} />
            <Route path="/messaging-policy" element={<MessagingPolicy />} />
            <Route path="/legal-disclaimer" element={<LegalDisclaimer />} />
          </Routes>
        </main>

        <footer>
          <div className="footer-content">
            <div className="contact-info">
              <p><strong>CONTACT US</strong></p>
              <p>1007 N Orange St. 4th Floor 2692 Wilmington, DE 19801 United States</p>
              <p>support@merigold.care</p>
              <p>+1-888-598-1651 | 3022235619</p>
            </div>

            <div className="terms-info">
              <p><strong>TERMS</strong></p>
              <p><a href="/terms-conditions">Terms and Conditions</a></p>
              <p><a href="/legal-disclaimer">Legal Disclaimer</a></p>
              <p><a href="/privacy-policy">Privacy Policy</a></p>
              <p><a href="/return-refund-policy">Return & Refund Policy</a></p>
              <p><a href='/messaging-policy'>SMS Mobile Messaging Policy</a></p>
            </div>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
